import React from "react";
import { Resources } from "../../../data/Resources";
import MediaFeedContentPage from "../media-feed/MediaFeedContentPage";

export const VideoFeedPage = () => {
  return <MediaFeedContentPage resource={Resources.VIDEOS} />;
};
